<template>
  <Catalogs
    title="Статусы исполнителей"
    create-text="Новый"
    :fetch-data="fetchData"
    :route-create="'WorkerStatusAdd'"
    :route-edit="'WorkerStatusEdit'"
    :route-view="'WorkerStatusView'"
    :route-path="'/worker_statuses'"
    :can-edit="canEditWorkerStatusCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "WorkerStatuses",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  methods: {
    async fetchData(data) {
      return await this.getWorkerStatuses(data);
    },
    canEditWorkerStatusCatalogs() {
      return this.hasPermission([PERM.CATALOG_WORKER_STATUS_EDIT]);
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkerStatuses/WorkerStatuses.vue